<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <h3 style=" font-size: 27px; text-align: center; font-weight: 600; padding-bottom: 30px; padding-top: 10px; ">All Parsha Donation</h3>

          <FormSection title="">
            <AmountSelectorAllparsha
              :showDedicationAndDate="showDedicationAndDate"
              :seriesPreselected="seriesPreselected"
            />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit />
            </div>
            <TransactionFee  v-if="form.amount"/>
          </FormSection>  
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>            
            <DonorAddress />
          </FormSection>

          <div
            v-if="
              getValue('custom.sponsorshipType') !== 'general' && showDedicationAndDate
            "
          >
            <FormSection title="Additional Information">
              <FormRow>
                <FormCol field="custom.dedicationType">
                  <div style="margin-top: 5px">
                    <FormSelect>
                      <option :value="null">Please Select</option>
                      <option>In Memory of</option>
                      <option>In Honor of</option>
                      <option>For the Refuah Sheleimah of</option>
                    </FormSelect>
                  </div>
                </FormCol>
              </FormRow>
              <FormRow inline class="dedication">
                <FormCol field="custom.dedication">
                  <FormInput type="textarea" maxlength="200" />
                  <div class="didcate__note">
                    Please enter the dedication message as you would like it to appear on
                    the platform.
                  </div>
                </FormCol>
              </FormRow>
              <FormRow inline>
                <FormCol field="custom.specialInstructions">
                  <FormInput type="textarea" />
                </FormCol>
              </FormRow>
              <br />
              <div v-if="form.amount && Number(form.amount) && Number(form.amount) > 1799" class="joinall">
                <FormRow inline>
                  <FormLabel>
                    <input
                      type="checkbox"
                      :checked="amudei"
                      @click="setValue('custom.amudei', !amudei)"
                    />
                    Your donation of $1800 or more qualifies you as an Amudei All Torah supporter.<br>  Can we add your name to our list of supporters?
                  </FormLabel>
                </FormRow>
              </div>
            </FormSection>
          </div>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt :receipts="['us', 'israel', 'canadian']" />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />

          <div class="footer-note">
            <template v-if="getValue('custom.sponsorshipType') !== 'general'">
              <div class="footer__note">
                Thank you for your generous support. Please note, due to the volume of
                shiurim and different recording times, the magid shiur cannot announce the
                dedication.
                <strong
                  >Your dedication will be prominently displayed on the webpage and app
                  for the entire duration of the sponsorship.</strong
                ><br />
                Tizku L’Mitzvos!
              </div>
            </template>
            Contact <a href="mailto:info@allparsha.org">info@allparsha.org</a> for more
            information and other dedication opportunities.
          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";
import { ref } from "vue";

export default defineComponent({
  setup() {
    const { setValue, getValue, form, testMode } = usePaymentForm();
    const amudei = computed(() => getValue("custom.amudei"));

    setValue(
      "callback",
      testMode
        ? "https://admin-outorah.oudev.org/allParshaDonationCallback"
        : "https://admin.outorah.org/allParshaDonationCallback"
    );

    const params = queryParams();

    const seriesPreselected = ref(false);

    if (params.seriesId) {
      seriesPreselected.value = true;

      setValue("custom.sponsorshipType", "shiur");
      setImmediate(() => {
        setValue("custom.programId", params.seriesId);
      });
    }

    watch(
      () => getValue("custom.dedicationType"),
      (val) => {
        if (val) {
          setValue("custom.dedication", getValue("custom.dedicationType") + " ");
        }
      }
    );

    return {
      getValue,
      amudei,
      form,
      setValue,
      seriesPreselected,
      showDedicationAndDate: computed(
        () =>
          !seriesPreselected.value ||
          (seriesPreselected.value && Number(getValue("amount")) >= 180)
      ),
      datepickerOptions: {
        format(date: Date) {
          return `Week of ${date.toDateString().split(" ").slice(1).join(" ")}`;
        },
        disabledDates: {
          days: [1, 2, 3, 4, 5, 6],
          to: new Date(),
        },
      },
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.footer-note {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}
.footer__note {
  font-style: italic;
  margin-top: 40px;
  margin-bottom: 20px;
  line-height: normal;
  text-align: center;
  font-size: 14px;
}

::v-deep .ou-donation-form {
  textarea {
    font-family: inherit;
    padding: 9px;
    font-size: 15px;
  }
}
::v-deep textarea {
  padding-top: 5px !important;
  ::-webkit-input-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  :-ms-input-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  :-moz-placeholder {
    font-family: inherit;
    line-height: normal;
  }

  ::-moz-placeholder {
    font-family: inherit;
    line-height: normal;
  }
}
.didcate__note {
  font-size: 13px;
  font-style: italic;
  padding-top: 3px;
  margin-bottom: 8px;
  line-height: normal;
}
::v-deep .joinall{

label{
  display: flex;
  align-items: center;
  gap: 10px;
}
input{
  width: auto;
  margin: 0px;
}

}
</style>
